import { acceptedFileFormats } from '@constants/URLs';
import { ErrorList as JobErrorList } from '@partful/features/job/ui/ErrorList/ErrorList';
import { Typography } from '@partful/shared/ui/Typography';
import { type KitsJob } from '@providers/job/types';
import { useTranslation } from 'react-i18next';

interface ErrorListProps {
  runID: string;
  kitsJobData: KitsJob;
}

export function ErrorList({ runID, kitsJobData }: Readonly<ErrorListProps>) {
  const { t } = useTranslation('createProduct');
  const { errors } = kitsJobData;

  return (
    <JobErrorList label={t('errorReference', { context: 'withMessage', message: runID })} errors={errors}>
      <Typography>
        {t('sbom.failure.checkKnowledgeBase')}{' '}
        <a href={acceptedFileFormats} target="_blank" rel="noreferrer">
          {t('sbom.failure.knowledgeBase')}
        </a>
        .
      </Typography>
      <Typography>{t('sbom.failure.tryUploadingAgain')}</Typography>
    </JobErrorList>
  );
}
